export default __webpack_public_path__ + "static/media/copy_book.5f4ea75b.svg";